module.exports = __webpack_public_path__ + "img/bg-hero.03b414a9.png";